import React, { useState } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../store/actions";

import ConnectButton from "./ConnectButton";
import SelectOption from "./SelectOption";

const Body = (props) => {
  const [state, setState] = useState({
    checkOption: "8hours",
  });

  const onClick = async () => {
    if (window.ethereum) {
      try {
        props.accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        if (props.accounts.length !== 0) {
          props.setAddress(props.accounts[0]);
          props.setShowMetaMaskButton(false);
          props.setShowFundOption(true);
        } else {
          props.setAddress("");
          props.setShowMetaMaskButton(true);
          props.setShowFundOption(false);
        }
      } catch (error) {
        // User denied account access
        console.log(error);
      }
    }
  };

  const optionChange = async (event) => {
    let value = event.target.value;
    if (event.target.value) {
      setState((previousState) => ({
        ...previousState,
        checkOption: value,
      }));
    }
  };

  const getFund = async () => {
    let optionId = 0;
    if (state.checkOption === "24hours") {
      optionId = 1;
    } else if (state.checkOption === "72hours") {
      optionId = 2;
    }
    props.setIsLoading(true);
    try {
      await props.faucet.methods.getFund(optionId).send({
        from: props.accounts[0],
      });
    } catch (error) {
      console.log("error: " + JSON.stringify(error));
      props.setIsLoading(false);
    }
  };

  return (
    <div>
      {props.showMetaMaskButton && <ConnectButton onClick={onClick} />}
      {props.showFundOption && (
        <SelectOption
          optionChange={optionChange}
          getFund={getFund}
          checkOption={state.checkOption}
          isLoading={props.isLoading}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.isLoading,
    showFundOption: state.showFundOption,
    showMetaMaskButton: state.showMetaMaskButton,
    accounts: state.accounts,
    faucet: state.faucet,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (value) =>
      dispatch({ type: actionTypes.SET_ISLOADING, value: value }),
    setAddress: (value) =>
      dispatch({ type: actionTypes.SET_ADDRESS, value: value }),
    setShowMetaMaskButton: (value) =>
      dispatch({ type: actionTypes.SET_SHOWMETAMASKBUTTON, value: value }),
    setShowFundOption: (value) =>
      dispatch({ type: actionTypes.SET_SHOWFUNDOPTION, value: value }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Body);
